import moment from 'moment'

export const formatLastContactedDate = (lastContactedDate) => {
    if (!lastContactedDate) return 'Never Contacted';
    return moment(lastContactedDate).format('MMM D, YYYY');
  };